import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Tooltip,
  Whisper,
  Stack,
  IconButton,
  InputGroup,
  Form,
  Message,
  Table,
  SelectPicker,
  toaster
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { ReviewPass } from '@rsuite/icons';
import { Popconfirm } from 'antd';

interface RowDataCollection {
  id: string; // or number, depending on your data
  attributes: {
    MatCollectionCode: string;
    MatCollectionName: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const CollectionMaster = () => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  ////////////////  Function For 3 Start /////////////////

  const [collection, setCollection] = useState({
    MatCollectionCode: '',
    MatCollectionName: '',
    dis: 'Continue'
  });
  // Fetch Data from API Start
  const [collectiondata, setCollectiondata] = useState<RowDataCollection[]>([]);
  const [collectionmeta, setCollectionmeta] = useState<MetaData>();
  const [editedRowIdsCollection, setEditedRowIdsCollection] = useState<string[]>([]);
  const [editedRowIdCollection, setEditedRowIdCollection] = useState<string>('');
  const [isLoading3, setIsLoading3] = React.useState(false);

  const [editedDataCollection, setEditedDataCollection] = useState<
    Record<string, Partial<RowDataCollection['attributes']>>
  >({});

  const [selectedBuyercoll, setSelectedBuyercoll] = useState('Continue');
  const [disData, setDisData] = useState([]);
  const handleBuyerChangecoll = value => {
    setSelectedBuyercoll(value);
  };

  useEffect(() => {
    fetchData3();
  }, [selectedBuyercoll]);
  const fetchData3 = async () => {
    if (isLoading3) {
      return;
    }
    setIsLoading3(true);
    let disFilter = '';
    if (selectedBuyercoll.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyercoll}`;
    }
    if (selectedBuyercoll == 'All') {
      disFilter = '';
    }
    // let disFilter = '';
    // if (selectedBuyercoll.length > 0 && selectedBuyercoll !== 'All') {
    //   disFilter = `&filters[dis][$eq]=${selectedBuyercoll}`;
    // }
    const pageResponse = await fetch(
      `${globalIP}/api/mstmaterialcollections?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const pageJson = await pageResponse.json();
    const allData = [];
    for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstmaterialcollections?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${globalIP}/api/mstmaterialcollections?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();

    const response = await fetch(`${globalIP}/api/mstmaterialcollections`);
    const pageJson2 = await response.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstmaterialcollections?populate=*&pagination[page]=${page}`
      );
      const pageJson2 = await pageResponse.json();
      allData2.push(...pageJson2.data);
    }
    setDisData(allData2);
    setCollectionmeta(jsonmeta.meta);
    setCollectiondata(allData);
    setIsLoading3(false);
  };
  const generateNextCategoryCode3 = () => {
    const nextCode = collectionmeta?.pagination?.total + 1;
    return `COL-${nextCode.toString().padStart(3, '0')}`;
  };
  const processInputRef = useRef(null);
  const handleEditRowCollection = rowData => {
    setCollection({ ...rowData.attributes });
    setEditedRowIdCollection(rowData.id);
    setEditedRowIdsCollection(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataCollection(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };
  const resetCollecyion = () => {
    setCollection({
      MatCollectionCode: '',
      MatCollectionName: '',
      dis: 'Continue'
    });
  };
  const handleCancelCollection = rowData => {
    resetCollecyion();
    setEditedRowIdCollection('');
    setEditedRowIdsCollection('');
  };
  let nextCategoryCode3 = generateNextCategoryCode3();
  const url3 = `${globalIP}/api/mstmaterialcollections`;

  const submit3 = async e => {
    e.preventDefault();

    const trimmedMatCollectionName = collection.MatCollectionName?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

    if (trimmedMatCollectionName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.Collection}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (specialCharPattern.test(trimmedMatCollectionName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.Collection} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const { data: collectnfilterData } = await axios.get(
          `${globalIP}/api/mstmaterialcollections?populate=*&filters[MatCollectionName][$eqi]=${trimmedMatCollectionName}`
        );
        console.log('collectnfilterData ---> ', collectnfilterData);
        const { data: collectnfiltercode } = await axios.get(
          `${globalIP}/api/mstmaterialcollections?populate=*`
        );
        const nextCode = collectnfiltercode.meta.pagination.total + 1;

        const existingCollection = disData.find(
          item =>
            item.attributes.MatCollectionName.toLowerCase() ===
            trimmedMatCollectionName.toLowerCase()
        );
        if (collectnfilterData.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              {label[0]?.attributes.Collection} {trimmedMatCollectionName} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          // Generate the next code and prepare form data
          const nextCategoryCode = generateNextCategoryCode3();
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              ...collection,
              MatCollectionName: trimmedMatCollectionName,
              MatCollectionCode: `COL-${nextCode.toString().padStart(3, '0')}`
            })
          );

          const response = await fetch(url3, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            await fetchData3(); // Wait for data to be fetched before logging
            console.log(collection);

            toaster.push(
              <Message showIcon type="success">
                Data Save Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }

      // Reset the collection state
      setCollection({
        MatCollectionCode: '',
        MatCollectionName: '',
        dis: 'Continue'
      });
    }
  };

  //  Fetch Data from API End
  const handleInputChange3 = (inputName, value, index) => {
    setCollection({ ...collection, [inputName]: value });
  };
  const handleCollC = async catalogId => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...collectiondata,
        dis: 'Continue'
      })
    );
    fetch(`${globalIP}/api/mstmaterialcollections/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData3();
        toaster.push(
          <Message showIcon type="success">
            Continue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleCollD = async catalogId => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...collectiondata,
        dis: 'Discontinue'
      })
    );
    fetch(`${globalIP}/api/mstmaterialcollections/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData3();
        toaster.push(
          <Message showIcon type="success">
            Discontinue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleSaveRowCollection = async () => {
    try {
      // const rowData = collectiondata.find(row => row.id === rowId);
      if (!collection) {
        console.error('Row data not found.');
        return;
      }

      // Trim `MatCollectionName` and check for special characters
      const updatedCollectionName = collection?.MatCollectionName?.trim() || '';
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

      if (!updatedCollectionName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.Collection}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (specialCharPattern.test(updatedCollectionName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.Collection} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      const { data: updatecollectnfilterData } = await axios.get(
        `${globalIP}/api/mstmaterialcollections?populate=*&filters[MatCollectionName][$eqi]=${updatedCollectionName}&filters[id][$ne]=${editedRowIdCollection}`
      );
      if (updatecollectnfilterData.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Collection} {updatedCollectionName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // // Update row data with trimmed `MatCollectionName`
      // const updatedRowData: RowDataCollection = {
      //   ...rowData,
      //   attributes: {
      //     ...rowData.attributes,
      //     ...editedDataCollection[rowId],
      //     MatCollectionName: updatedCollectionName
      //   }
      // };

      const response = await fetch(
        `${globalIP}/api/mstmaterialcollections/${editedRowIdCollection}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: { ...collection, MatCollectionName: updatedCollectionName }
          })
        }
      );

      if (response.ok) {
        // Refresh data and update edited row IDs if the save was successful
        fetchData3();
        resetCollecyion('');
        setEditedRowIdCollection('');
        setEditedDataCollection(prevData => ({
          ...prevData,
          [editedRowIdCollection]: { ...collection, MatCollectionName: updatedCollectionName } // Ensure UI updates correctly
        }));
        setEditedRowIdsCollection(prevRowIds => [
          ...new Set([...prevRowIds, editedRowIdCollection])
        ]);
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };
  const handleSaveRowCollection1 = async (rowId: string) => {
    try {
      const rowData = collectiondata.find(row => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }

      // Trim `MatCollectionName` and check for special characters
      const updatedCollectionName = editedDataCollection[rowId]?.MatCollectionName?.trim();
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;
      const { data: updatecollectnfilterData } = await axios.get(
        `${globalIP}/api/mstmaterialcollections?populate=*&filters[MatCollectionName][$eqi]=${updatedCollectionName}&filters[id][$ne]=${rowId}`
      );
      if (!updatedCollectionName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.Collection}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (specialCharPattern.test(updatedCollectionName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.Collection} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      if (updatecollectnfilterData.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Collection} {updatedCollectionName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // Update row data with trimmed `MatCollectionName`
      const updatedRowData: RowDataCollection = {
        ...rowData,
        attributes: {
          ...rowData.attributes,
          ...editedDataCollection[rowId],
          MatCollectionName: updatedCollectionName
        }
      };

      const response = await fetch(`${globalIP}/api/mstmaterialcollections/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: updatedRowData.attributes })
      });

      if (response.ok) {
        // Refresh data and update edited row IDs if the save was successful
        fetchData3();
        setEditedRowIdsCollection(prevRowIds => prevRowIds.filter(id => id !== rowId));
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeCollection = (rowId, fieldName, value) => {
    setEditedDataCollection(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...collectiondata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  ////////////////  Function For 3 End /////////////////
  ////////////////  Searching For 3 Start /////////////////
  const [searchQuery3, setSearchQuery3] = useState('');
  [];
  const [filterStatus3, setFilteredStatus3] = useState('Continue');
  const handleSearch3 = value => {
    setSearchQuery3(value);
  };
  const [filterCollectionData, setFilterCollectionData] = useState([]);
  useEffect(() => {
    const filterCollectionData = collectiondata.filter(item => {
      const MatCollectionName = item.attributes.MatCollectionName
        ? item.attributes.MatCollectionName.toLowerCase()
        : '';
      return MatCollectionName.includes(searchQuery3.toLowerCase());
    });

    setFilterCollectionData(filterCollectionData);
  }, [collectiondata, filterStatus3, searchQuery3]);
  ////////////////  Searching For 3 End /////////////////
  return (
    <>
      <Form.ControlLabel>
        <b>{label[0]?.attributes.Collection}</b>
      </Form.ControlLabel>
      <Stack justifyContent="space-between" style={{ marginBottom: '10px' }} className="mstr-panel">
        <Stack spacing={160} className="mstr-panel1">
          <Input
            id="MatCollectionName"
            name="MatCollectionName"
            style={{ width: '180%' }}
            autoComplete="off"
            ref={processInputRef}
            value={collection && collection.MatCollectionName ? collection.MatCollectionName : ''}
            onChange={value => handleInputChange3('MatCollectionName', value, 0)}
            onPressEnter={submit3}
          />
          {editedRowIdCollection ? (
            <Button
              appearance="primary"
              color="cyan"
              onClick={handleSaveRowCollection}
              className="mstr-btn"
              style={{ marginLeft: '10px' }}
            >
              {' '}
              Update
            </Button>
          ) : (
            <Button
              appearance="primary"
              color="cyan"
              onClick={submit3}
              className="mstr-btn"
              style={{ marginLeft: '10px' }}
            >
              {' '}
              Add
            </Button>
          )}
        </Stack>
        <Stack className="mstr-search" spacing={5} style={{ marginLeft: '7px' }}>
          <SelectPicker
            data={data}
            placeholder="Status"
            labelKey="label"
            value={selectedBuyercoll}
            onChange={handleBuyerChangecoll}
            searchable={false}
            valueKey="value"
            size="md"
            appearance="default"
            style={{ width: 130 }}
            cleanable={false}
          />
          <InputGroup inside>
            <Input placeholder="Search" type="text" value={searchQuery3} onChange={handleSearch3} />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
      <Table
        rowHeight={60}
        data={filterCollectionData}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading3}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
        </Table.Column>

        <Table.Column width={130} flexGrow={1}>
          <Table.HeaderCell>
            <b>{label[0]?.attributes.Collection}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                // editedRowIdsCollection.includes(rowData.id) ? (
                //   <Input
                //     value={editedDataCollection[rowData.id]?.MatCollectionName || ''}
                //     onChange={value =>
                //       handleInputChangeCollection(rowData.id, 'MatCollectionName', value)
                //     }
                //   />
                // ) : (
                rowData.attributes.MatCollectionName
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsCollection.includes(rowData.id) ? (
                <div>
                  {/* <IconButton
                    size="sm"
                    icon={<CheckIcon />}
                    active
                    onClick={() => handleSaveRowCollection(rowData.id)}
                    style={{ marginRight: '10px' }}
                  /> */}
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    style={{ marginRight: '10px' }}
                    onClick={() => handleEditRowCollection(rowData)}
                  />
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={handleCancelCollection}
                  // onClick={() =>
                  //   setEditedRowIdsCollection(prevRowIds =>
                  //     prevRowIds.filter(id => id !== rowData.id)
                  //   )
                  // }
                  />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowCollection(rowData)}
                  />
                  {rowData.attributes.dis === 'Discontinue' ? (
                    <Popconfirm
                      title="Continue Library"
                      description="Are you sure you want to continue this Library?"
                      onConfirm={() => handleCollC(rowData.id)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Continue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<CheckRoundIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleCollC(rowData.id)}
                        />
                      </Whisper>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Discontinue Library"
                      description="Are you sure you want to discontinue this Library?"
                      onConfirm={() => handleCollD(rowData.id)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Discontinue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<ReviewPass />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleCollD(rowData.id)}
                        />
                      </Whisper>
                    </Popconfirm>
                  )}
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <div>
        <p>
          <small>Total row:{filterCollectionData.length}</small>
        </p>
      </div>
    </>
  );
};

export default CollectionMaster;
